'use strict';

module.exports = {
  addClass: require('./addClass'),
  removeClass: require('./removeClass'),
  hasClass: require('./hasClass')
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/dom-helpers/class/index.js
 ** module id = 440
 ** module chunks = 0
 **/